import { Icon, Menu } from "@chakra-ui/react";
import React from "react";
import { IconType } from "react-icons";
import useThemeColors from "../../hooks/useThemeColors";

interface Props {
  menuItems: {
    label: string;
    value: string;
    icon: IconType;
    onClick: () => void;
  }[];
  trigger: React.ReactNode;
}

const CustomMenu = ({ menuItems, trigger }: Props) => {
  const colors = useThemeColors();
  return (
    <Menu.Root>
      <Menu.Trigger asChild>{trigger}</Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content>
          {menuItems.map((item) => (
            <Menu.Item
              key={item.value}
              onClick={item.onClick}
              value={item.value}
            >
              <Icon
                as={item.icon}
                mr={2}
                boxSize={5}
                color={colors.schoolAccent.icon}
              />
              {item.label}
            </Menu.Item>
          ))}
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
};

export default CustomMenu;
